<div [ngClass]="{'page-container': currentPortal !== PortalType.Normal}">
  <app-tabs-header
    [labelText]="'Search Brokers'"
    [matTooltip]="'Search by broker name OR number'"
    [showButton]="true"
    [iconName]="'add'"
    [buttonText]="'Add Broker'"
    (valueChanged)="onValueChanged($event)"
    (emitClickEvent)="onClickAddBroker()">
  </app-tabs-header>
  
  <section class="mat-elevation-z8 table-container">
    <table [dataSource]="dataSource"
           mat-table matSort multiTemplateDataRows
           (matSortChange)="sortData($event)">
      
      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <greydom-icon-navigate customTooltip="Edit Broker"
                                 [icon]="DisplayIcon.Edit"
                                 (onClick)="onClickEditBroker(row.brokerId)">
          </greydom-icon-navigate>
        </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.BrokerId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let row" mat-cell>{{row.brokerId}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.BrokerNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Broker Number</th>
        <td *matCellDef="let row" mat-cell>{{row.brokerNumber}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Broker Name</th>
        <td *matCellDef="let row" mat-cell>{{row.name}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.BrokerGroup">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Broker Group</th>
        <td *matCellDef="let row" mat-cell>{{row.brokerGroup?.name}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.BusinessType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Business Type</th>
        <td *matCellDef="let row" mat-cell>{{row.businessType?.name}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.EntityStatus">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Entity Status</th>
        <td *matCellDef="let row" mat-cell>{{row.entityStatus?.name}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.StartDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let row" mat-cell>{{row.startDate | date: dateFormat}}</td>
      </ng-container>
      
      <!-- Expanded Row -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="displayedColumns.length" mat-cell>
          <div [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Business License Expiry: </b>{{row.businessLicenseExpiryDate | date: dateFormat}}<br>
            <b>Business License Scanned Copy: </b>{{row.businessLicenseScannedCopy}}<br>
            <b>License Number: </b>{{row.businessLicenseNumber}}<br>
            <b>VAT Number: </b>{{row.vatNumber}}<br>
            <b>VAT Override: </b>{{row.vatOveride}}<br>
            <b>GST Number: </b>{{row.gstNumber}}<br>
            <b>GST Override: </b>{{row.gstOverride}}<br>
            <b>Sanction Indicator: </b>{{row.sanctionIndicator}}<br>
            <b>Sanction Reference: </b>{{row.sanctionReference}}<br>
            <b>Sanction Check Date: </b>{{row.sanctionCheckDate | date: dateFormat}}<br>
            <b>End Date: </b>{{row.endDate | date: dateFormat}}<br>
            <b>Bank Account: </b>{{row.bankAccount?.name}}<br>
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>
      
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="expandedElement = expandedElement === row ? null : row"
          *matRowDef="let row; columns: displayedColumns;"
          [class.expanded-row]="expandedElement == row" class="row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    
    </table>
    
    <mat-paginator (page)="pageChanged($event)"
                   [length]="brokerTableControl.length"
                   [pageIndex]="brokerTableControl.pageNumber"
                   [pageSizeOptions]="brokerTableControl.pageSizeOptions"
                   [pageSize]="brokerTableControl.pageSize">
    </mat-paginator>
  </section>
</div>